module.exports = __webpack_public_path__ + "img/jimny-glx-blanco.349f430d.png";